require('./utils/bootstrap');

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Vuelidate from 'vuelidate';
import VueSocialSharing from 'vue-social-sharing';
import VueNumericInput from 'vue-numeric-input';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';

import router from './router/router';
import store from './store/store';
import init from './plugins/init';
import plugins from './plugins/plugins';
import { i18n } from './plugins/i18n';

import mdiVue from 'mdi-vue/v3';
import * as mdijs from '@mdi/js';

import theShop from './components/TheShop';
import TheEmbed from './components/TheEmbed';
import DynamicLink from './components/inc/DynamicLink.vue';
import Banner from './components/inc/Banner.vue';
import ProductBox from './components/product/ProductBox';
import ProductBox2 from './components/product/ProductBox_v2';
import AppDatePicker from './components/common/AppDatePicker.vue';
import AppDateRangePicker from './components/common/AppDateRangePicker.vue';
import AppDateTimePicker from './components/common/AppDateTimePicker.vue';
import VueSweetalert2 from 'vue-sweetalert2';

import EventManager from './utils/EventManager.js';
import CompressionHelper from './utils/CompressionHelper.js';
import Mixin from './utils/mixin.js';
import visitTracker from './utils/visitTracker';

import 'sweetalert2/dist/sweetalert2.min.css';

VueClipboard.config.autoSetContainer = true;

window.Vue = require('vue');

Vue.use(VueClipboard);
Vue.use(VueNumericInput);
Vue.use(VueSocialSharing);
Vue.use(VueAwesomeSwiper);
Vue.use(plugins);
Vue.use(VueRouter);
Vue.use(Vuetify);
Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(mdiVue, { icons: mdijs });
Vue.use(VueSweetalert2);
Vue.use(EventManager);
Vue.use(CompressionHelper);
Vue.mixin(Mixin);
Vue.component('dynamic-link', DynamicLink);
Vue.component('banner', Banner);
Vue.component('product-box', ProductBox);
Vue.component('product-box2', ProductBox2);
Vue.component('app-date-picker', AppDatePicker);
Vue.component('app-date-range-picker', AppDateRangePicker);
Vue.component('app-date-time-picker', AppDateTimePicker);

init(store, router);

// 방문자 추적 초기화
visitTracker.init();

// 전역 Promise rejection 핸들러 - 네비게이션 가드 리다이렉트 에러 처리
window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    // 네비게이션 가드 리다이렉트 관련 에러는 무시
    if (
        error?.name === 'NavigationCancelled' ||
        error?.name === 'NavigationDuplicated' ||
        error?.message?.includes('Redirected when going from') ||
        error?.message?.includes('via a navigation guard')
    ) {
        event.preventDefault();
        return;
    }
    // 다른 에러는 기본 동작 유지 (콘솔에 표시)
});

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === 'development';

const app = new Vue({
    i18n,
    router,
    store,
    vuetify: new Vuetify(),
    el: '#app',
    render(h) {
        var url = new URL(window.location.href);
        var urlSegment = url.pathname.split('/');
        var urlParams = new URLSearchParams(url.search);

        if (urlSegment[1] == 'embed') {
            if (urlParams.has('path')) this.$store.state.estimate.params.path = urlParams.get('path');
            if (urlParams.has('type')) this.$store.state.estimate.params.type = urlParams.get('type');
            if (urlParams.has('order_detail_id')) this.$store.state.estimate.params.order_id = urlParams.get('order_detail_id');

            if (!urlParams.has('path') && !urlParams.has('type') && !urlParams.has('order_detail_id')) {
                this.$store.state.estimate.params.path = urlParams.get('path');
                this.$store.state.estimate.params.type = urlParams.get('type');
            }

            return h(TheEmbed);
        } else if (urlSegment[1] == 'm') {
            return h(TheEmbed);
        } else {
            return h(theShop);
        }
    },
});
